import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import type { OriginalRootState } from 'redux/rootReducer'
import { GetAuthTokenResponse } from 'services/authToken'
import { AuthTokenState } from 'typings/reduxStore'

export const initState: AuthTokenState = {
  tokenInfo: {} as GetAuthTokenResponse | null
}

const authTokenSlice = createSlice({
  name: 'authTokenSlice',
  initialState: initState,
  reducers: {
    updateAuthToken: (
      state: AuthTokenState,
      action: PayloadAction<{ tokenInfo: GetAuthTokenResponse }>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    },
    /**
     * Handles logout for this slice. Ideally, this reducer would be added in
     * extra reducers and handle the onLogout action. However, importing that
     * action from the loginInfoSlice runs into a complex dependency cycle.
     * Therefore, this action has been created as a temporary work around.
     */
    logout: state => {
      state.tokenInfo = {} as GetAuthTokenResponse
    },
    /** V3Auth Flow: Authenticate or token request failed */
    loginError: state => {
      state.tokenInfo = null
    },
    /**
     * Action occurs when a new token request is fulfilled.
     *
     * Unable to move to extraBuilders attached to the thunk responsible for
     * fetching the token because of cyclic dependencies.
     */
    tokenRequestSuccess: (
      state,
      action: PayloadAction<GetAuthTokenResponse>
    ) => {
      state.tokenInfo = action.payload
    }
  }
})

export const { updateAuthToken, logout, loginError, tokenRequestSuccess } =
  authTokenSlice.actions

export default authTokenSlice.reducer

/** Returns the access token string from the store */
export const selectAccessToken = (state: OriginalRootState): string =>
  state.authTokenInfo?.tokenInfo?.access_token || ''
